import React, { useState } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import ScoreBreakdown from "./ScoreBreakdown";

const OpportunityCard = ({
  opportunity,
  actionsDisabled = false,
  createPostDisabled = false,
  createPostDisabledReason = null,
  onCreatePost,
  onDismiss,
  onSave,
  onMarkUsed,
}) => {
  const [breakdownOpen, setBreakdownOpen] = useState(false);
  const evidence = opportunity.liveEvidence || {};
  const evidenceSummary =
    evidence.primaryFact?.claim ||
    evidence.allowedClaims?.[0] ||
    opportunity.headline;
  const repetitionPenalty =
    opportunity.scoreComponents?.repetitionPenalty || 0;

  return (
    <Card component="article" variant="outlined">
      <CardContent>
        <Stack spacing={1.5}>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Chip label={opportunity.type} size="small" />
            <Chip label={opportunity.sport} size="small" variant="outlined" />
            <Typography variant="h5" fontWeight={800}>
              {opportunity.score}
            </Typography>
          </Stack>

          <Typography>{opportunity.reason}</Typography>
          {evidenceSummary && (
            <Typography color="text.secondary" variant="body2">
              {evidenceSummary}
            </Typography>
          )}
          {evidence.destinationUrl && (
            <Link href={evidence.destinationUrl}>
              {evidence.destinationUrl}
            </Link>
          )}
          {repetitionPenalty > 0 && (
            <Typography color="warning.main" variant="body2">
              Repetition penalty: {repetitionPenalty}
            </Typography>
          )}
          {createPostDisabled && createPostDisabledReason && (
            <Typography color="text.secondary" variant="body2">
              {createPostDisabledReason}
            </Typography>
          )}

          <ScoreBreakdown
            components={opportunity.scoreComponents}
            expanded={breakdownOpen}
            onToggle={() => setBreakdownOpen((open) => !open)}
          />
        </Stack>
      </CardContent>
      <CardActions sx={{ flexWrap: "wrap" }}>
        <Button
          disabled={actionsDisabled || createPostDisabled}
          onClick={() => onCreatePost(opportunity)}
          variant="contained"
        >
          Create post
        </Button>
        <Button
          disabled={actionsDisabled}
          onClick={() => onSave(opportunity.opportunityKey)}
        >
          Save
        </Button>
        <Button
          disabled={actionsDisabled}
          onClick={() => onDismiss(opportunity.opportunityKey)}
        >
          Dismiss
        </Button>
        <Button
          disabled={actionsDisabled}
          onClick={() => onMarkUsed(opportunity.opportunityKey)}
        >
          Mark used
        </Button>
      </CardActions>
    </Card>
  );
};

export default OpportunityCard;
